export default [
    {
        productMetafield: {
            namespace: 'custom',
            key: 'product_stock_status',
            value: 'ACTIVE',
        },
    },
];
